import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import styled, { useTheme } from 'styled-components';
var TooltipContent = /*#__PURE__*/styled(TooltipPrimitive.Content).withConfig({
  displayName: "Tooltip__TooltipContent",
  componentId: "sc-ya8k7d-0"
})(["z-index:9999;background-color:", ";border-radius:4px;padding:0;max-width:", ";box-shadow:0 4px 8px rgba(0,0,0,0.12);user-select:none;animation-duration:400ms;animation-timing-function:cubic-bezier(0.16,1,0.3,1);will-change:transform,opacity;&[data-state='delayed-open'][data-side='top']{animation-name:slideDownAndFade;}&[data-state='delayed-open'][data-side='right']{animation-name:slideLeftAndFade;}&[data-state='delayed-open'][data-side='bottom']{animation-name:slideUpAndFade;}&[data-state='delayed-open'][data-side='left']{animation-name:slideRightAndFade;}@keyframes slideUpAndFade{from{opacity:0;transform:translateY(2px);}to{opacity:1;transform:translateY(0);}}@keyframes slideRightAndFade{from{opacity:0;transform:translateX(-2px);}to{opacity:1;transform:translateX(0);}}@keyframes slideDownAndFade{from{opacity:0;transform:translateY(-2px);}to{opacity:1;transform:translateY(0);}}@keyframes slideLeftAndFade{from{opacity:0;transform:translateX(2px);}to{opacity:1;transform:translateX(0);}}", ""], function (props) {
  return props.$backgroundColor;
}, function (props) {
  return props.$maxWidth ? "".concat(props.$maxWidth, "px") : 'none';
}, function (props) {
  if (!props.$customStyles) return '';
  if (typeof props.$customStyles === 'function') {
    var styles = props.$customStyles(props.theme);
    return Object.entries(styles).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      // Convert camelCase to kebab-case for CSS properties
      var cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      return "".concat(cssKey, ": ").concat(value, ";");
    }).join('\n');
  }
  return Object.entries(props.$customStyles).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    // Convert camelCase to kebab-case for CSS properties
    var cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
    return "".concat(cssKey, ": ").concat(value, ";");
  }).join('\n');
});
var TooltipArrow = /*#__PURE__*/styled(TooltipPrimitive.Arrow).withConfig({
  displayName: "Tooltip__TooltipArrow",
  componentId: "sc-ya8k7d-1"
})(["fill:", ";"], function (props) {
  return props.$color;
});
var TooltipContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Tooltip__TooltipContentWrapper",
  componentId: "sc-ya8k7d-2"
})(["font-family:", ";", ";pointer-events:auto;cursor:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.kallisto.font.family.sans;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.kallisto.mixins.padding({
    ver: 'space100',
    hor: 'space150'
  });
}, function (props) {
  return props.$clickable ? 'pointer' : '';
});
var TooltipTitle = /*#__PURE__*/styled.div.withConfig({
  displayName: "Tooltip__TooltipTitle",
  componentId: "sc-ya8k7d-3"
})(["color:", ";", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.kallisto.color.text.static.textInverse;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.kallisto.mixins.font('Title6');
});
var TooltipContentText = /*#__PURE__*/styled.div.withConfig({
  displayName: "Tooltip__TooltipContentText",
  componentId: "sc-ya8k7d-4"
})(["color:", ";", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.kallisto.color.text.static.textInverse;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.kallisto.mixins.font('BodySmall');
});
export var Tooltip = function Tooltip(_ref1) {
  var content = _ref1.content,
    open = _ref1.open,
    title = _ref1.title,
    _ref1$placement = _ref1.placement,
    placement = _ref1$placement === void 0 ? 'top' : _ref1$placement,
    _ref1$maxWidth = _ref1.maxWidth,
    maxWidth = _ref1$maxWidth === void 0 ? 300 : _ref1$maxWidth,
    tooltipSx = _ref1.tooltipSx,
    _ref1$disablePortal = _ref1.disablePortal,
    disablePortal = _ref1$disablePortal === void 0 ? true : _ref1$disablePortal,
    _ref1$enterDelay = _ref1.enterDelay,
    enterDelay = _ref1$enterDelay === void 0 ? 0 : _ref1$enterDelay,
    children = _ref1.children,
    onClick = _ref1.onClick;
  var baseTheme = /*#__PURE__*/useTheme();
  var contentElement = /*#__PURE__*/React.createElement(TooltipContentWrapper, {
    onClick: onClick,
    $clickable: !!onClick
  }, title && /*#__PURE__*/React.createElement(TooltipTitle, null, title), /*#__PURE__*/React.createElement(TooltipContentText, null, content));
  return /*#__PURE__*/React.createElement(TooltipPrimitive.Provider, {
    delayDuration: enterDelay
  }, /*#__PURE__*/React.createElement(TooltipPrimitive.Root, {
    open: open
  }, /*#__PURE__*/React.createElement(TooltipPrimitive.Trigger, {
    asChild: true
  }, children), /*#__PURE__*/React.createElement(TooltipPrimitive.Portal, {
    container: disablePortal ? null : undefined
  }, /*#__PURE__*/React.createElement(TooltipContent, {
    side: placement,
    $maxWidth: maxWidth,
    $backgroundColor: baseTheme.kallisto.color.background.static.backgroundNeutralContrast,
    $customStyles: tooltipSx,
    sideOffset: 9
  }, contentElement, /*#__PURE__*/React.createElement(TooltipArrow, {
    $color: baseTheme.kallisto.color.background.static.backgroundNeutralContrast
  })))));
};